import { ToggleButton, ToggleButtonGroup } from '@mui/material'

/**
 * Two to four mutually exclusive views of one thing, side by side — the
 * toggle in a Panel header (Sequenced / Totalled). Small (26px), squared,
 * the selected segment on teal-tint in brand teal.
 */
export const SegmentedControl = <T extends string>({
  value,
  options,
  onChange,
  label,
}: {
  value: T
  options: { value: T; label: string }[]
  onChange: (value: T) => void
  label: string
}) => (
  <ToggleButtonGroup
    exclusive
    size="small"
    value={value}
    aria-label={label}
    onChange={(_event, next: T | null) => next && onChange(next)}
    sx={{
      '& .MuiToggleButton-root': {
        height: 'var(--control-h-sm)',
        px: '10px',
        py: 0,
        fontSize: 11.5,
        fontWeight: 600,
        textTransform: 'none',
        color: 'var(--ink-500)',
        borderColor: 'var(--line-300)',
        background: 'var(--surface-0)',
        '&:hover': { background: 'var(--surface-50)' },
        '&.Mui-selected, &.Mui-selected:hover': {
          background: 'var(--teal-tint)',
          color: 'var(--brand-teal)',
        },
      },
    }}
  >
    {options.map((option) => (
      <ToggleButton key={option.value} value={option.value} disableRipple>
        {option.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
)
